import { Context } from "@nuxt/types";

import Api from "@/utils/api";

export default class FollowerStatisticsApi extends Api {
  readonly url = "/followers_statistics/";

  constructor($axios: Context["$axios"]) {
    super("followerService", $axios);
  }

  async getFollowerStatistics(profileId: string) {
    return await this.request<FollowersStatisticsResponse>({
      method: "GET",
      params: {
        profile_id: profileId,
      },
    });
  }
}
